<template>
  <footer class="footer-container" :class="{ 'no-margin': noMarginPages.includes($route.name) }">
    <div class="footer-inner">
      <div class="footer-content">
        <div class="footer-left">
          <div class="footer-logo">
            <img src="@/assets/new_picture/LOGO_b.png" alt="英才计划" class="logo-image" />
          </div>
          <p class="footer-description">
            国内兼具口碑与实力的职业培训机构
          </p>
          <div class="footer-qrcodes">
            <div class="qrcode-item">
              <img src="@/assets/wechat_service1.png" alt="企业客服" class="qrcode" />
              <p class="qrcode-text">企业客服</p>
            </div>
            <div class="qrcode-item">
              <img src="@/assets/wechat_service2.png" alt="企业客服" class="qrcode" />
              <p class="qrcode-text">企业客服</p>
            </div>
          </div>
        </div>
        <div class="footer-right">
          <div class="footer-link-group">
            <h3 class="link-group-title">快捷导航</h3>
            <ul class="link-list">
              <li><router-link to="/agreement/user_agreement" class="link-item">用户协议</router-link></li>
              <li><router-link to="/agreement/privacy_policy" class="link-item">隐私政策</router-link></li>
              <li><router-link to="/agreement/copyright_statement" class="link-item">版权声明</router-link></li>
              <li><router-link to="/agreement/legal_statement" class="link-item">法律声明</router-link></li>
              <li><router-link to="/agreement/disclaimer" class="link-item">免责条款</router-link></li>
              <li><router-link to="/agreement/social_responsibility" class="link-item">社会责任</router-link></li>
              <li><router-link to="/agreement/market_cooperation" class="link-item">市场合作</router-link></li>
            </ul>
          </div>
          
          <div class="footer-link-group">
            <h3 class="link-group-title">联系我们</h3>
            <ul class="link-list">
              <li class="link-item">北京市昌平区YBD云集中心4栋1101室</li>
              <li class="link-item">电话：400-100-0000</li>
              <li class="link-item">邮箱：us@yingcai.com</li>
              <li class="link-item">邮编：100094</li>
            </ul>
          </div>
          
          <div class="footer-link-group">
            <h3 class="link-group-title">防诈提示</h3>
            <ul class="link-list">
              <li class="link-item">防诈声明</li>
              <li class="link-item">禁止代收款</li>
              <li class="link-item">警务电话：400-100-0000</li>
            </ul>
          </div>
          
          <div class="footer-link-group">
            <h3 class="link-group-title">友情链接</h3>
            <ul class="link-list">
              <li><a href="https://www.neea.edu.cn/" target="_blank" class="link-item">中国教育网</a></li>
              <li><a href="http://www.chinapeixun.org.cn/" target="_blank" class="link-item">中国培训网</a></li>
              <li><a href="http://www.educational.org.cn/" target="_blank" class="link-item">中国学习网</a></li>
              <li><a href="https://www.neea.edu.cn/" target="_blank" class="link-item">中国考试网</a></li>
              <li><a href="http://cx.cnca.cn/CertECloud/index/index/page" target="_blank" class="link-item">中国认证网</a></li>
              <li><a href="https://chinajob.mohrss.gov.cn/h5/" target="_blank" class="link-item">中国就业网</a></li>
            </ul>
          </div>
        </div>
      </div>
      
      <div class="footer-bottom">
        <div class="strip">
          <div class="strip-inner">
            <div class="icp-line">经营许可证编号：京ICP00058809-9 | 备案ICP号159034号 | 网站ICP备1101080212687401240017号</div>
            <div class="copy-line">Copyright © 2005-2025 yingcaijihua.com 版权所有 | 北京趋势动力科技有限公司</div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
  data() {
    return {
      noMarginPages: ['certification']
    }
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
.footer-container {
  background-color: #f5f3ff;
  background-image: url('~@/assets/footer_bg.png');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  color: #333333;
  padding: 40px 0 0;
  margin-top: 0;
  position: relative;
}

.footer-container.no-margin {
  margin-top: 0;
}
.footer-container::before {
  content: '';
  position: absolute;
  inset: 0;
  background: radial-gradient(1200px 300px at 80% 30%, rgba(124,58,237,.08), transparent 60%), radial-gradient(1200px 300px at 20% 30%, rgba(59,130,246,.06), transparent 60%);
  pointer-events: none;
  z-index: 0;
}

.footer-inner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  position: relative;
  z-index: 1;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 40px;
  gap: 40px;
}

.footer-left {
  width: 300px;
}

.footer-logo {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-bottom: 8px;
}

.logo-image {
  width: 140px;
}

.footer-description {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  line-height: 1.6;
  margin-bottom: 24px;
}

.footer-qrcodes {
  display: flex;
  gap: 20px;
}

.qrcode-item {
  text-align: center;
}

.qrcode {
  width: 100px;
  height: 100px;
  background-color: #ffffff;
  border: 1px solid #e5e7eb;
  padding: 4px;
  border-radius: 4px;
  margin-bottom: 8px;
}

.qrcode-text {
  font-size: 12px;
  color: #666666;
}

.footer-right {
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1;
  padding-top: 40px;
}

.footer-link-group {
  display: flex;
  align-items: flex-start;
  gap: 16px;
}

.link-group-title {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  margin-bottom: 0;
  min-width: 70px;
  line-height: 1.6;
}

.link-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 8px 20px;
  flex: 1;
}

.link-item {
  display: inline-block;
  font-size: 14px;
  color: #666666;
  text-decoration: none;
  transition: color 0.3s;
  line-height: 1.6;
}
.link-item:hover { color: #3E2CCD; }

.footer-bottom {
  margin-top: 20px;
  width: 100vw;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
}
.strip {
  background: #3E2CCD;
  color: #fff;
  padding: 14px 0;
}
.strip-inner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  font-size: 12px;
  line-height: 1.8;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.icp-line, .copy-line { opacity: .95; }

.copyright {
  font-size: 13px;
  color: #999999;
  text-align: center;
}

@media (max-width: 992px) {
  .footer-content {
    flex-direction: column;
    gap: 30px;
  }
  
  .footer-left {
    width: 100%;
  }
  
  .footer-right {
    flex-wrap: wrap;
    gap: 30px;
  }
}
</style>
